var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 33") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social-icons",
    transform: "translate(-103.000000, -3.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.45175,23.45025 L119.89225,23.45025 L119.89225,17.88075 C119.89225,16.5525 119.86975,14.844 118.04275,14.844 C116.191,14.844 115.90825,16.2915 115.90825,17.7855 L115.90825,23.45025 L112.3525,23.45025 L112.3525,11.997 L115.765,11.997 L115.765,13.563 L115.81375,13.563 C116.2885,12.66225 117.4495,11.71275 119.18125,11.71275 C122.78575,11.71275 123.45175,14.08425 123.45175,17.169 L123.45175,23.45025 Z M108.33925,10.4325 C107.1955,10.4325 106.27375,9.50775 106.27375,8.36775 C106.27375,7.2285 107.1955,6.30375 108.33925,6.30375 C109.47775,6.30375 110.4025,7.2285 110.4025,8.36775 C110.4025,9.50775 109.47775,10.4325 108.33925,10.4325 L108.33925,10.4325 Z M110.11975,23.45025 L106.5565,23.45025 L106.5565,11.997 L110.11975,11.997 L110.11975,23.45025 Z M126.00025,3 L104.0005,3 C103.44775,3 103,3.44775 103,3.99975 L103,25.9995 C103,26.55225 103.44775,27 104.0005,27 L126.00025,27 C126.55225,27 127,26.55225 127,25.9995 L127,3.99975 C127,3.44775 126.55225,3 126.00025,3 L126.00025,3 Z",
    id: "Fill-33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/LINKEDIN.1fe39ec82793c32a16264140d1a03247.svg";
export { ForwardRef as ReactComponent };